// extracted by mini-css-extract-plugin
export default {"container":"ImplantPage_container__30ECq","page":"ImplantPage_page__KektH","back":"ImplantPage_back__UCPlZ"};